import { action } from "typesafe-actions"

import { type PFDPreviewSagaPayload, type SearchPlateSagaPayload } from "./sagas"
import { type OneFleetEntregaForm, OneFleetEntregaFormsTypes } from "./types"

export const setData = (data: OneFleetEntregaForm): { type: OneFleetEntregaFormsTypes.SET_DATA } => action(OneFleetEntregaFormsTypes.SET_DATA, { data })
export const clearData = (): { type: OneFleetEntregaFormsTypes.CLEAR_DATA } => action(OneFleetEntregaFormsTypes.CLEAR_DATA, { data: {} })

export const PDFPreview = (data: PFDPreviewSagaPayload): { type: OneFleetEntregaFormsTypes.PREVIEW_PDF_REQUEST } => action(OneFleetEntregaFormsTypes.PREVIEW_PDF_REQUEST, data)
export const PDFPreviewClear = (): { type: OneFleetEntregaFormsTypes.PREVIEW_PDF_CLEAR } => action(OneFleetEntregaFormsTypes.PREVIEW_PDF_CLEAR)
export const PDFPreviewSuccess = (data: Buffer): { type: OneFleetEntregaFormsTypes.PREVIEW_PDF_SUCCESS } => action(OneFleetEntregaFormsTypes.PREVIEW_PDF_SUCCESS, data)
export const PDFPreviewFailure = (data: string): { type: OneFleetEntregaFormsTypes.PREVIEW_PDF_FAILURE } => action(OneFleetEntregaFormsTypes.PREVIEW_PDF_FAILURE, data)

export const PlateData = (data: SearchPlateSagaPayload): { type: OneFleetEntregaFormsTypes.SEARCH_PLATE_REQUEST } => action(OneFleetEntregaFormsTypes.SEARCH_PLATE_REQUEST, data)
export const PlateDataClear = (): { type: OneFleetEntregaFormsTypes.SEARCH_PLATE_CLEAR } => action(OneFleetEntregaFormsTypes.SEARCH_PLATE_CLEAR)
export const PlateDataSuccess = (data: unknown): { type: OneFleetEntregaFormsTypes.SEARCH_PLATE_SUCCESS } => action(OneFleetEntregaFormsTypes.SEARCH_PLATE_SUCCESS, data)
export const PlateDataFailure = (data: string): { type: OneFleetEntregaFormsTypes.SEARCH_PLATE_FAILURE } => action(OneFleetEntregaFormsTypes.SEARCH_PLATE_FAILURE, data)

export default {
  setData,
  clearData,

  PDFPreview,
  PDFPreviewClear,
  PDFPreviewSuccess,
  PDFPreviewFailure,

  PlateData,
  PlateDataClear,
  PlateDataSuccess,
  PlateDataFailure
}
